const _licenseCategory = {
  BOAT:   0,
  MARINE: 1,
  OTHERS: 2
};

const _boatOperatorLicenseOptions = [
  {
    label: "1級",
    value: 1
  },
  {
    label: "1級+特殊",
    value: 4
  },
  {
    label: "2級",
    value: 2
  },
  {
    label: "2級+特殊",
    value: 5
  },
  {
    label: "特殊",
    value: 3
  }
];

const _marineLicenseCategoryOptions = [
  {
    label: "海技士(航海士)",
    value: 1
  },
  {
    label: "海技士(機関士)",
    value: 2
  }
  // {
  //   label: "海技士 (通信)",
  //   value: 3,
  // },
  // {
  //   label: "海技士 (電子通信)",
  //   value: 4,
  // },
];

const _marineEngineerLicenseOptions = [
  {
    label: "1級機関士",
    value: 6
  },
  {
    label: "2級機関士",
    value: 7
  },
  {
    label: "3級機関士",
    value: 8
  },
  {
    label: "4級機関士",
    value: 9
  },
  {
    label: "5級機関士",
    value: 10
  },
  {
    label: "6級機関士",
    value: 11
  }
];

const _marineNavigatorLicenseOptions = [
  {
    label: "1級航海士",
    value: 12
  },
  {
    label: "2級航海士",
    value: 13
  },
  {
    label: "3級航海士",
    value: 14
  },
  {
    label: "4級航海士",
    value: 15
  },
  {
    label: "5級航海士",
    value: 16
  },
  {
    label: "6級航海士",
    value: 17
  }
];

const _marineOthersLicenseOptions = [
  {
    label: "その他",
    value: 18
  }
];

const _allOptions = _boatOperatorLicenseOptions
  .concat(_marineEngineerLicenseOptions)
  .concat(_marineNavigatorLicenseOptions)
  .concat(_marineOthersLicenseOptions);

// TODO: この定義ここでいいのか？ Modelフォルダでimportして使う方が。。
class RequestEnterpriseUserLicense {
  constructor() {
    this.address = null;
    this.birthday = null;
    this.certificate_number = null;
    this.delivery_date = null;
    this.expiration_date = null;
    this.gender = null;
    this.legal_domicile = null;
    this.license_type_id = null;
    this.name = null;
    this.name_en = null;
    this.register_date = null;
  }
}

export default {
  data() {
    return {
      licenseCategory: _licenseCategory,
      boatOperatorLicenseOptions: _boatOperatorLicenseOptions,
      marineLicenseCategoryOptions: _marineLicenseCategoryOptions,
      marineOthersLicenseOptions: _marineOthersLicenseOptions
    };
  },
  methods: {
    newRequestModel() {
      return new RequestEnterpriseUserLicense();
    },
    isBoatLicense(licenseNum) {
      return licenseNum <= 5;
    },
    isMarineEngineerLicense(licenseNum) {
      return licenseNum >= 6 && licenseNum <= 11;
    },
    isMarineNavigatorLicense(licenseNum) {
      return licenseNum >= 12 && licenseNum <= 17;
    },
    isMarineLicense(licenseNum) {
      return (this.isMarineEngineerLicense(licenseNum) || this.isMarineNavigatorLicense(licenseNum))
    },
    isOthersLicense(licenseNum) {
      return licenseNum === 18;
    },
    getLicenseCategoryById(licenseTypeId) {
      if (this.isBoatLicense(licenseTypeId)) {
        return _licenseCategory.BOAT;
      }
      if (this.isMarineEngineerLicense(licenseTypeId)) {
        return _licenseCategory.MARINE;
      }
      if (this.isMarineNavigatorLicense(licenseTypeId)) {
        return _licenseCategory.MARINE;
      }
      return _licenseCategory.OTHERS;
    },
    getMarinerLicenseCategoryOptionsById(licenseTypeId) {
      if (this.isMarineNavigatorLicense(licenseTypeId)) {
        return _marineLicenseCategoryOptions[0];
      }
      if (this.isMarineEngineerLicense(licenseTypeId)) {
        return _marineLicenseCategoryOptions[1];
      }
    },
    getMarinerClassOptions(marineLicenseCategory) {
      switch (marineLicenseCategory) {
        case _marineLicenseCategoryOptions[0].value:
          return _marineNavigatorLicenseOptions;
        case _marineLicenseCategoryOptions[1].value:
          return _marineEngineerLicenseOptions;
      }
    },
    findLicenseLabelById(licenseTypeId) {
      let target = _allOptions.find(item => {
        return String(item.value) === licenseTypeId;
      });
      return target.label;
    },
    findLicenseOption(licenseTypeId) {
      let option = _allOptions.find(item => {
        return String(item.value) === licenseTypeId;
      });
      return option;
    },
    getLicenseCategoryLabel(licenseTypeId) {
      if(this.isBoatLicense(licenseTypeId)) {
        return "小型船舶";
      }
      if(this.isMarineLicense(licenseTypeId)) {
        return "海技士";
      }
      return "その他";
    }
  }
};
